import RLPError from '../ErrorPage/RLPError';

const getDisabledItemsFromMutuallyExclusiveFilter = (mutuallyExclusiveFilterState) => {
  let disabledItems = [];
  try {
    const disabledItemsForMutuallyExclusiveState =
      mutuallyExclusiveFilterState.itemState.mutuallyExclusiveFilter.mutuallyExclusiveFilterDisabledMap.get(
        mutuallyExclusiveFilterState.itemState.value
      );

    if (disabledItemsForMutuallyExclusiveState && disabledItemsForMutuallyExclusiveState.length > 0) {
      disabledItems = disabledItemsForMutuallyExclusiveState;
    }
  } catch (err) {
    new RLPError(
      { payload: mutuallyExclusiveFilterState },
      `unable to determine disabled items from the supplied mutuallyExclusive filter state ${mutuallyExclusiveFilterState}`,
      err
    ).log();
  }
  return disabledItems;
};

const disableFilterItems = (items, disabledItemValues) => {
  return disabledItemValues && disabledItemValues.length > 0
    ? items.map((item) => {
        const updatedItem = Object.assign({}, item);
        if (
          disabledItemValues.find((disabledItemValue) => {
            return disabledItemValue === item.value;
          })
        ) {
          updatedItem.isDisabled = true;
        }
        return updatedItem;
      })
    : items;
};

/**
 * This creates an handler function which updates the state of a filter when it's clicked.
 *
 * When a user clicks a filter, in addition to setting the filters new value,
 * this will calculate all combinations of filtering on the mutuallyExclusive filter (via the supplied mutuallyExclusiveFilteringFn).
 * Any combination which yields 0 results will be stored within the 'itemState.mutuallyExclusiveFilter' state.
 * The information is stored in a map keyed on filter value.
 *
 * for instance the report level filter would hold this about its mutuallyExclusive:
 *
 * itemState {
 *  mutuallyExclusiveFilter{
 *          id: 'whatImDoingFilter'
 *          mutuallyExclusiveFilterDisabledMap: Map {
 *              {
 *                  key: 'classLevel'
 *                  value: ['talkingWithFamiliesAndStudents']
 *              }
 *              {
 *                  key: 'studentLevel'
 *                  value: ['talkingWithFamiliesAndStudents']
 *              }
 *          }
 *      }
 * }
 *
 * i.e. When the Report Level filter has a value of 'classLevel' or 'studentLevel', the 'whatImDoingFilter'
 * should have the 'talkingWithFamiliesAndStudents' filter option disabled
 *
 * isFilterCombinationDisabledFn - should return true if the combination of itemValue & mutuallyExclusiveValue result in 0 reports.
 */
const getItemValueAndMutuallyExclusiveFilterHandler = (isFilterCombinationDisabledFn) => {
  return (itemValue) => {
    return (itemState) => {
      itemState.value = itemValue;

      if (itemState.mutuallyExclusiveFilter) {
        if (!itemState.mutuallyExclusiveFilter.mutuallyExclusiveFilterDisabledMap.get(itemValue)) {
          // initialize the disabled items to an empty array - i.e. no items are disabled
          let disabledMutuallyExclusiveItemValues = [];
          // Calculate results of filtering item value on this filter + all combinations of mutuallyExclusive filter value
          Object.values(itemState.mutuallyExclusiveFilter.mutuallyExclusiveFilterValues).forEach(
            (mutuallyExclusiveValue) => {
              if (isFilterCombinationDisabledFn(mutuallyExclusiveValue, itemValue)) {
                disabledMutuallyExclusiveItemValues.push(mutuallyExclusiveValue);
              }
            }
          );
          itemState.mutuallyExclusiveFilter.mutuallyExclusiveFilterDisabledMap.set(
            itemValue,
            disabledMutuallyExclusiveItemValues
          );
        }
      }
    };
  };
};

export default {
  disableFilterItems,
  getDisabledItemsFromMutuallyExclusiveFilter,
  getItemValueAndMutuallyExclusiveFilterHandler,
};
